import type { AuthAdapter, AuthUser } from "./types";
import { orangecatAdapter } from "./orangecatAdapter";
import { localAdapter } from "./localAdapter";

export * from "./types";

export interface AuthHub {
  user: AuthUser | null;
  adapter: AuthAdapter;
  ready: boolean;
}

export async function bootAuth(): Promise<AuthHub> {
  try {
    const u = await orangecatAdapter.getSession();
    if (u) return { user: u, adapter: orangecatAdapter, ready: true };
  } catch {
    /* */
  }
  const local = await localAdapter.getSession();
  // Prefer Orangecat for submits even if guest — it will 401 and we fall back.
  return {
    user: local,
    adapter: hybridAdapter(local),
    ready: true,
  };
}

function hybridAdapter(localUser: AuthUser | null): AuthAdapter {
  return {
    id: localUser ? "local" : "orangecat",
    getSession: async () => {
      const o = await orangecatAdapter.getSession();
      if (o) return o;
      return localAdapter.getSession();
    },
    login: async (u, p) => {
      const a = await orangecatAdapter.login(u, p);
      if (a.ok) return a;
      return localAdapter.login(u, p);
    },
    register: async (u, p, e) => {
      const a = await orangecatAdapter.register(u, p, e);
      if (a.ok) return a;
      return localAdapter.register(u, p, e);
    },
    logout: async () => {
      await orangecatAdapter.logout();
      await localAdapter.logout();
    },
    submitScore: async (payload) => {
      const session = await orangecatAdapter.getSession();
      if (session) {
        const r = await orangecatAdapter.submitScore(payload);
        if (r.ok || r.rejected) return r;
      }
      return localAdapter.submitScore(payload);
    },
    getLeaderboard: async (q) => {
      const remote = await orangecatAdapter.getLeaderboard(q);
      if (remote && remote.length) return remote;
      return localAdapter.getLeaderboard(q);
    },
    getProgress: (g) => orangecatAdapter.getProgress(g),
    saveProgress: (g, s) => orangecatAdapter.saveProgress?.(g, s),
    listProfiles: () => orangecatAdapter.listProfiles?.() ?? Promise.resolve([]),
    saveProfile: (p) => orangecatAdapter.saveProfile?.(p) ?? Promise.resolve(),
    generateClassCode: () => orangecatAdapter.generateClassCode?.() ?? Promise.resolve(""),
  };
}
